import * as types from './sessions.types';
import * as constants from './sessions.constants';
import { ISession, ISessionSave, ISessionSearchParams, ISessionUpdate } from '../../../resource/session/session.types';
import { IUser } from '../../../resource/user/user.types';

export const fetchSessions = (searchParams?: ISessionSearchParams): types.IFetchSessions => ({
  type: constants.FETCH_SESSIONS,
  payload: searchParams,
});

export const createSession = (session: ISession): types.ICreateSession => ({
  type: constants.CREATE_SESSION,
  payload: session,
});

export const updateSession = (sessionId: ISession['id'], session: ISessionUpdate): types.IUpdateSession => ({
  type: constants.UPDATE_SESSION,
  payload: {
    id: sessionId,
    data: session,
  },
});

export const saveSession = (id: ISession['id'], data: ISessionSave): types.ISaveSessionSocket => ({
  type: constants.SAVE_SESSION_SOCKET,
  payload: data,
});

export const saveEmail = (sessionId: ISession['id'], email: string): types.ISaveEmail => ({
  type: constants.SAVE_EMAIL,
  payload: {
    id: sessionId,
    email: email,
  },
});

export const deleteSession = (sessionId: ISession['id']): types.IDeleteSession => ({
  type: constants.DELETE_SESSION,
  payload: sessionId,
});

export const storeSessionIds = (sessionIds: ISession['id'][]): types.IStoreFetchedSessions => ({
  type: constants.STORE_SESSION_IDS,
  payload: sessionIds,
});

export const clearSessionIds = (): types.IClearFetchedSessions => ({
  type: constants.CLEAR_SESSION_IDS,
});

export const storeNextSession = (nextSessionId: ISession['id']): types.IStoreNextSession => ({
  type: constants.STORE_NEXT_SESSION,
  payload: nextSessionId,
});

export const clearNextSession = (): types.IClearNextSession => ({
  type: constants.CLEAR_NEXT_SESSION,
});

export const storeLastSession = (lastSessionId: ISession['id'] | null): types.IStoreLastSession => ({
  type: constants.STORE_LAST_SESSION,
  payload: lastSessionId,
});

export const clearLastSession = (): types.IClearLastSession => ({
  type: constants.CLEAR_LAST_SESSION,
});

export const storeNotAttended = (notAttended: IUser['id'][]): types.IStoreNotAttended => ({
  type: constants.STORE_NOT_ATTENDED,
  payload: notAttended,
});

export const clearNotAttended = (): types.IClearNotAttended => ({
  type: constants.CLEAR_NOT_ATTENDED,
});
